import DOMPurify from "dompurify"

export function b64DecodeUnicode(str: string) {
  return decodeURIComponent(Array.prototype.map.call(atob(str), function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))
}

export function innerHtml(html: string) {
  return {dangerouslySetInnerHTML: {__html: DOMPurify.sanitize(html)}};
}

export function stripHtml(input: string): string {
    const dom = new DOMParser().parseFromString(input, 'text/html')
    return dom.body.textContent || ''
}